import { MessageKey } from "@/i18n";
import { PaymentMethod, PaymentStatus } from "@/types";

export const PAYMENT_METHOD_LABELS: {
  [key in PaymentMethod]: MessageKey;
} = {
  bankTransfer: "payment.type.bankTransfer",
  cash: "payment.type.cash",
  free: "payment.type.free",
  online: "payment.type.online",
  invoice: "payment.type.invoice",
  wechat: "payment.type.wechat",
};

export const PAYMENT_STATUS_LABELS: {
  [key in PaymentStatus]: MessageKey;
} = {
  completed: "payment.status.completed",
  expired: "payment.status.expired",
  refunded: "payment.status.refunded",
  canceled: "payment.status.canceled",
  pending: "payment.status.pending",
  partiallyPaid: "payment.status.partiallyPaid",
  failed: "payment.status.failed",
};

/**
 * Upper bound the backend enforces on every money input (`@Max(1_000_000)` on
 * the fee/price DTO fields — DEV-4494). Mirrored client-side so a fat-fingered
 * extra zero surfaces as an inline field error instead of a 400 from the API.
 * Keep in sync with the backend DTO bounds.
 */
export const MAX_MONEY_VALUE = 1_000_000;

/**
 * Upper bound the backend enforces on every percentage-fee input (`@Max(100)`).
 * Most percentage fields already hard-code `100`; use this where a shared
 * constant reads better than the literal.
 */
export const MAX_PERCENTAGE_VALUE = 100;

/**
 * VAT rate (percent) the backend applies to the Tournated fee when a level
 * switches VAT on without storing a rate (`DEFAULT_TOURNATED_FEE_VAT_RATE`).
 * The editor pre-fills it on enabling and displays it for a stored `null`.
 */
export const DEFAULT_TOURNATED_FEE_VAT_RATE = 21;
